import invoice from './invoice.json';
import invoiceOut from './invoiceOut.json';
import inventoryVed from './inventoryVed.json';
import inventorySved from './inventorySved.json';
import kizInventory from './kizInventory.json';
import importRemains from './importRemains.json';
import movement from './movement.json';
import actRevaluation from './actRevaluation.json';
import actDisagregation from './actDisagregation.json';
import actDisassembling from './actDisassembling.json';
import actDeduction from './actDeduction.json';
import requestForMovement from './requestForMovement.json';
import invoiceCashOrder from './invoiceCashOrder.json';
import bunchInvoices from './bunchInvoices.json';
import globalImportInvoices from './globalImportInvoices.json';
import actRejection from './actRejection.json';

export default {
  invoice,
  invoiceOut,
  inventoryVed,
  inventorySved,
  kizInventory,
  importRemains,
  movement,
  actRevaluation,
  actDisagregation,
  actDisassembling,
  actDeduction,
  requestForMovement,
  invoiceCashOrder,
  bunchInvoices,
  globalImportInvoices,
  actRejection
};